import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Col, Row, Spin} from "antd";
import './ListCategoryRiskCard.scss'

import LargeCardDashboard from "../CardDashboard/LargeCardDashobard/LargeCardDashobard";
import { getClientsPromise } from "../../../../../Register/promises";
import {camelizerHelper} from "../../../../../../helpers";


const ListCategoryRiskCard = ({categories, globalActiveCategory, handleTabAlertas}) => {

    const {t} = useTranslation()

    const colorRisk = (score) => {
        if (score === 0) return 'GREEN'
        if (score === 1) return 'YELLOW'
        if (score === 2) return 'ORANGE'
        if (score === 3) return 'RED'
        if (score === 4) return 'BLACK'
    }

    const defaultRisk = [{title: t('messages.aml.critical'), value: null, score: 4},
        {title: t('messages.aml.high'), value: null, score: 3},
        {title: t('messages.aml.medium'), value: null, score: 2},
        {title: t('messages.aml.low'), value: null, score: 1}
    ]

    const [activeCategory, setActiveCategory] = useState(globalActiveCategory);
    const [riskData, setRiskData] = useState([])

    useEffect(() => {
        handleSearch()

    }, [activeCategory]);

    const handleSearch = () => {
        setRiskData(defaultRisk.map(r => ({ ...r, value: null })))

        Promise.all(defaultRisk.map((r) => {
            const color = colorRisk(r.score)
            let filter = {
                amlStatus: color,
                version: 'opensearch'
            }
            if(activeCategory) filter.category = activeCategory
            return getClientsPromise(0, 4, filter).then(records => ({
                ...r,
                value: records.records
            }))
        })).then(results => {
            setRiskData(results)
        })
    }

    const handleSetActiveCategory = (category) => {
        setActiveCategory(category);
    };

    const getFilters = (score, rut) => {
        let filters = {amlStatus: [colorRisk(score)]}
        if(activeCategory) filters.categories = [activeCategory]
        if(rut) filters.text = rut

        return filters
    }

    const RiskResume = () => {
        return (
            <>
                <div className={"risk-list-resume-content"}>
                    <Row gutter={[50, 0]}>
                        <br/>

                        {Object.values(riskData).map((risk, index) =>
                            <>
                                <Col span={6} key={index}>
                                    <a onClick={() => handleTabAlertas(getFilters(risk.score), 'records')}>
                                        <h3 className={'title-list-risk'}> {risk.title} </h3>
                                    </a>

                                    <div className="list-value-risk">
                                        {risk.value ?
                                            (risk.value.length > 0 ?
                                                risk.value.map(record =>
                                                    <a onClick={() => handleTabAlertas(getFilters(risk.score, record.rut), 'records')}>
                                                        <div className="value-text">{camelizerHelper(record.nombre.toString().trim())}</div>
                                                    </a>
                                                )
                                            :
                                                <p className="no-result">{t('messages.aml.withoutResults')}</p>
                                            )
                                        :
                                            <div className="spinner">
                                                <Spin spinning={true} size="large"/>
                                            </div>
                                        }
                                    </div>
                                </Col>
                            </>
                        )
                        }

                    </Row>
                </div>
            </>
        )
    }

    return (
        <>
            <div className='list-category-risk'>
                <LargeCardDashboard
                    key={activeCategory}
                    title={t("messages.aml.monitor.list.risk.of." + activeCategory)}
                    legend={t("messages.aml.monitor.list.leyend." + activeCategory)}
                    content={RiskResume()}
                    handleSetActiveCategory={handleSetActiveCategory}
                    activeCategory={activeCategory}
                    categories={categories}
                />
            </div>
        </>
    )
}

export default ListCategoryRiskCard;
